import styled from 'styled-components';

export const ScMyCurrencies = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
